// @flow
import { PUBLIC_URL, APP_ENV, FALLBACK_BRAND_ID } from '@alphaott/app-config'

export const BRAND_CONFIG_PATH = '/brand_config.json'
export const FALLBACK_BRAND_CONFIG_PATH =
  APP_ENV === 'stage'
    ? `${PUBLIC_URL}/brands/stage/brand_config.json`
    : `${PUBLIC_URL}/brands/${FALLBACK_BRAND_ID}/brand_config.json`
